<template>
  <section class="icon-text">
    <div class="icon-text__icon-container"
         v-if="blockContent.icon"
         v-html="blockContent.icon"></div>
    <p class="icon-text__paragraph" v-html="blockContent.paragraph"></p>
    <Button v-if="buttonContent"
            :buttonContent="buttonContent"/>
  </section>
</template>

<script>
import Button from './Button'

export default {
  name: 'IconText',
  components: {
    Button
  },
  props: {
    blockContent: {
      type: Object,
      default: function () {
        return {
          icon: `<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="150" height="150"
          	 viewBox="0 0 209.961 209.961" style="enable-background:new 0 0 209.961 209.961;" xml:space="preserve">
          <g>
          	<path style="fill:#e61919;" d="M206.573,61.016l-30.757-20.167c-1.222-0.801-2.651-1.228-4.112-1.228h-53.436V28.105c0-10.636-8.652-19.288-19.288-19.288
          		S79.692,17.47,79.692,28.105v44.311H38.257c-1.219,0-2.419,0.297-3.496,0.865L4.004,89.489c-2.35,1.238-3.869,3.625-3.995,6.278
          		c-0.127,2.652,1.158,5.173,3.379,6.629l30.757,20.167c1.222,0.801,2.651,1.228,4.112,1.228h41.436v62.353H64.73
          		c-4.143,0-7.5,3.358-7.5,7.5s3.357,7.5,7.5,7.5h68.5c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-14.962V90.995h53.436
          		c1.219,0,2.419-0.297,3.496-0.865l30.757-16.208c2.35-1.238,3.869-3.625,3.995-6.278C210.079,64.993,208.794,62.472,206.573,61.016
          		z M40.496,108.791L22.252,96.828l17.86-9.412h39.58v21.375H40.496z M94.692,186.143V28.105c0-2.364,1.924-4.288,4.288-4.288
          		s4.288,1.924,4.288,4.288v158.038H94.692z M169.848,75.995h-51.58V54.621h51.196l18.244,11.963L169.848,75.995z"/>
          </g>
          </svg>`,
          paragraph: 'Celem i wizją firmy jest dostarczenie Klientowi produktu najwyższej jakości, zgodnego ze wszelkimi obowiązującymi standardami - na czas i w pełni. Zawsze działamy w zgodzie z polityką wewnętrzną i obowiązującymi normami.'
        }
      }
    },
    buttonContent: {
      type: Object,
      default: function () {
        return {
          url: '#',
          label: 'DOWIEDZ SIĘ WIECEJ',
        }
      }
    }
  }
}
</script>

<style lang="sass">
  @import 'src/assets/stylesheets/style.sass'
</style>
